
/**
 * 画面ロック要素
 */
export default {
  name: 'Lock'
};
